import React from 'react';
import { ResponsiveTooltip, Typography } from '../../../../components';
import { IcDate, ClockIc } from '../../../../components/icons';
import { PartnerOrderData } from '../types';
import { useTranslations } from '../../../../contexts/translation.context';
import { formatTimeAgo } from '../../../../utils/formatTimeAgo';
import { Tooltip } from '@heroui/react';

interface DateCellProps {
  order: PartnerOrderData;
}

const DateCell: React.FC<DateCellProps> = ({ order }) => {
  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-2">
      <ResponsiveTooltip
        content={
          <div className="flex flex-col">
            <Typography variant="body3" className="text-auth-muted">
              {t('partner.orders.createdAtOffer')}:
            </Typography>
            <Typography variant="body2">{formatTimeAgo(order.createdAt, t)}</Typography>
          </div>
        }
        placement="top"
      >
        <div className="flex items-center gap-1 ">
          <IcDate className="w-3.5 h-3.5 text-gray-600" />
          <Typography variant="body3" className="text-gray-600">
            {formatTimeAgo(order.createdAt, t)}
          </Typography>
        </div>
      </ResponsiveTooltip>
      <ResponsiveTooltip
        content={
          <div className="flex flex-col">
            <Typography variant="body3" className="text-auth-muted">
              {t('partner.orders.duration')}:
            </Typography>
            <Typography variant="body2">
              {t('partner.orders.from')} {formatTimeAgo(order.createdAt, t)}
            </Typography>
            <Typography variant="body2">
              {t('partner.orders.to')} {formatTimeAgo(order.createdAt, t)}
            </Typography>
          </div>
        }
        placement="top"
      >
        <div className="flex items-center gap-1 ">
          <ClockIc />
          <Typography variant="body3" className="text-gray-600">
            {formatTimeAgo(order.createdAt, t)}
          </Typography>
        </div>
      </ResponsiveTooltip>
    </div>
  );
};

export default DateCell;
